export default __webpack_public_path__ + "static/media/iguzzini.9d73e3ec.png";